module.exports = __webpack_public_path__ + "static/media/d3kz.f5725cc7.pdf";